/**
 * Optimization Harness settings contracts — RO-2-09e / #44418.
 *
 * Ported from `excellent/src/optimization/settings-actions.ts`:
 *
 *   saveOptimizationConfigForm → POST /api/settings/agents/optimization
 *   saveCompileAutorunForm     → already POST /api/compilations/autorun
 *                                 (`compilations.setAutorun`, models.ts);
 *                                 NOT re-mounted here to avoid a fork.
 *
 * FormData fields reshape to JSON with the same names the settings form
 * already submits. Percent fields arrive as 0–100 in the form and are stored
 * as 0–1 — matching the source action's `num(...)/100` conversion.
 *
 * Live Next call site (`settings/agents/optimization/page.tsx`) stays on the
 * server action (`ccb89192`).
 *
 * Dropped `revalidatePath`: `/settings/agents/optimization` (L5 handoff).
 */

import { z } from "zod";
import type { Operation } from "../types";

const configBody = z.object({
  enabled: z.boolean(),
  budget_tokens_daily: z.number().optional(),
  budget_usd_daily: z.number().optional(),
  cadence_after_n_verdicts: z.number().optional(),
  cadence_on_regression: z.boolean().optional(),
  cadence_nightly_time: z.string().optional(),
  judge_model: z.string().optional(),
  /** 0–100 from the form; handler divides by 100. */
  judge_agreement_target_pct: z.number().optional(),
  /** 0–100 from the form; handler divides by 100. */
  confidence_threshold_pct: z.number().optional(),
});
export type OptimizationConfigBody = z.infer<typeof configBody>;

const saveConfigOp: Operation<void, void, OptimizationConfigBody, { ok: true }> = {
  method: "POST",
  path: () => "/api/settings/agents/optimization",
  body: configBody,
  response: z.object({ ok: z.literal(true) }),
};

export const optimizationSettings = {
  saveConfig: saveConfigOp,
};
